// test1275
(1275 && 0);
